// @owners { team: patients }
import { type AddOnOtc } from '@alto/scriptdash/alto/patient_app/add_ons/types/v1/add_on_otc';
import { useMemo } from 'react';
// eslint-disable-next-line @typescript-eslint/no-require-imports
const fsaEligibleImage = require('../assets/fsa-eligible.png');

type Props = {
  addOnOtc?: AddOnOtc;
};

export const useEssentialsFsaBadge = ({ addOnOtc }: Props = {}) => {
  const showFsaBadge = addOnOtc?.fsa_hsa_eligible;
  const showFsaTag = !!showFsaBadge;

  return useMemo(
    () => ({
      showFsaBadge,
      showFsaTag,
      fsaEligibleImage: showFsaTag ? undefined : fsaEligibleImage,
    }),
    [showFsaBadge, showFsaTag],
  );
};
